module.exports = __webpack_public_path__ + "img/060_schema_thumb.d65766c6.jpg";